import {acceptHMRUpdate} from 'pinia'
import type {TimerState} from '~/types'

export const useTimerStore = defineStore('timer', {
    persist: {
        storage: sessionStorage,
        afterRestore: (ctx) => {
            ctx.store.$state._startTime = new Date(ctx.store.$state._startTime)
            console.log(`just restored '${ctx.store.$state._startTime}'`)
        },
        // paths: ['_session']
        key: 'g4s-timer',
    },
    state: (): {
        _state: TimerState,
        _startTime: Date | null,
        _duration: number,
        _currentTime: Date | null,
    } => {
        return {
            _state: 'none',
            _startTime: null,
            _duration: 0,
            _currentTime: null,
        }
    },
    getters: {
        // from state
        state: (state): TimerState => {
            return state._state;
        },

        startTime: (state): Date | null => {
            return state._startTime
        },

        currentTime: (state): Date | null => {
            return state._currentTime
        },

        durationInMs: (state): number => {
            return state._duration * 60 * 1000
        },

        // from getters and other stores
        timeFactor(): number {
            const runtimeConfig = useRuntimeConfig()
            return runtimeConfig.public.dev ? 10 : 1
        },

        elapsed(): number {
            if (this.startTime instanceof Date && this.currentTime instanceof Date)
                return this.currentTime.getTime() - this.startTime.getTime()
            else
                return 0
        },

        timeLeft(): number {
            return (this.durationInMs) - this.elapsed
        },

        timeLeftFormat(): string {
            function padTo2Digits(num: number) {
                return num.toString().padStart(2, '0');
            }

            function convertMsToTime(milliseconds: number) {

                if (milliseconds < 0)
                    return '0:00'
                
                let seconds = Math.floor(milliseconds / 1000);
                let minutes = Math.floor(seconds / 60);
                let hours = Math.floor(minutes / 60);

                seconds = seconds % 60;
                // minutes = minutes % 60;

                // 👇️ If you don't want to roll hours over, e.g. 24 to 00
                // 👇️ comment (or remove) the line below
                // commenting next line gets you `24:00:00` instead of `00:00:00`
                // or `36:15:31` instead of `12:15:31`, etc.
                // hours = hours % 24;

                return `${padTo2Digits(minutes)}:${padTo2Digits(
                    seconds,
                )}`;
            }

            return convertMsToTime(this.timeLeft)
        },

        percentage(): number {
            const percentage = (this.timeLeft / this.durationInMs) * 100
            return (percentage < 0) ? 0 : (percentage > 100) ? 100 : percentage
        },
    },

    actions: {
        start(payload: number) {
            console.log('start timer', this.state, payload)
            if (this.state != 'started') {
                this._duration = payload / this.timeFactor
                this._state = 'started'
                this._startTime = new Date()
            }
        },

        setTime() {
            this._currentTime = new Date()
        },

        stop() {
            this._duration = 0
            this._state = 'done'
            this._startTime = null
            console.log('stop timer', this._startTime)
        },
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useTimerStore, import.meta.hot))
}